export default __webpack_public_path__ + "static/media/game.b127d759.png";